import { routes as leaseRoutes } from './lease'
import { routes as ontarioLeaseRoutes } from './ontario-lease'
import { routes as quebecLeaseRoutes } from './quebec-lease'

export const routes = {
  ...leaseRoutes,
  ...ontarioLeaseRoutes,
  ...quebecLeaseRoutes,
}
